import classnames from "classnames";
import * as React from "react";

export interface BlinkingOnClickChildProps {
    onTouchStart: () => void;
    className?: string;
}
export interface BlinkingOnClickComponentProps {
    readonly children: React.ReactElement<any>;
    readonly activeClassName: string;
}

export interface BlinkingOnClickComponentState {
    readonly wasTapped: boolean;
}

/**
 * Component is designed to add css effects while clicking on its child.
 *
 * Effects can not be implemented solely in css by using :active pseudo class
 * due to the issue with embedded browser on MachineApp.
 *
 * Embedded browser does not attach :active to html elements while using touch
 * screen on Machine. Moreover, touchstart and touchend events are not triggered.
 * Therefore mousedown and mouseup are the events that trigger an effect.
 */
export default class BlinkingOnClickComponent extends React.Component<
    BlinkingOnClickComponentProps,
    BlinkingOnClickComponentState
> {
    constructor(props: BlinkingOnClickComponentProps) {
        super(props);
        this.state = { wasTapped: false };
    }

    public componentDidMount() {
        document.addEventListener("mouseup", this.onTouchEnd, true);
    }

    public componentWillUnmount() {
        document.removeEventListener("mouseup", this.onTouchEnd);
    }

    public render() {
        const className = this.state.wasTapped
            ? classnames(
                  this.props.activeClassName,
                  this.props.children.props.className
              )
            : this.props.children.props.className;
        return React.cloneElement(this.props.children, {
            className,
            onMouseDown: this.onComponentTouched
        });
    }

    private onComponentTouched = () => {
        this.setState({
            wasTapped: true
        });
    };

    private onTouchEnd = () => {
        setTimeout(
            () =>
                this.setState(({ wasTapped }) => {
                    return wasTapped ? { wasTapped: false } : null;
                }),
            100
        );
    };
}
